
    <div class="container-fluid container-md">
        <div class="row ">
            <!-- LEFT SIDE BAR -->
            <div class="col-sm-2 col-md-3 d-flex flex-column text-sm-end text-md-start align-items-lg-start left_sidebar border-end">
                <app-left-sidebar [Username]="Username"></app-left-sidebar>
            </div>

            <!-- MAIN SECTION -->
            <div class="col-12 col-sm-10 col-md-9 col-lg-6  main_bar ">
                <div class="row d-flex justify-content-between align-items-center ps-1">
                    <div class="col-1 pt-2">
                        <div><span class="fs-4 fw-bold">Profile Test</span></div>
                    </div>
                    <div class="col-1 me-3">
                        <div><span class="fs-4"><i class="fa fa-star"></i> </span></div>
                    </div>
                </div>
                <div class="row mt-4">
                    <div class="col pt-2 ">
                        <!--<div class="profile-banner" [style.background-image]="'url(' + BannerImageUrl + ')'">
                            <img class="profile-image" [src]="'/img_profile/' + UserID + '/' + UserImg" alt="User Profile">
                        </div>-->
                        <div>
                            <app-profile-menu-page-top 
                                    *ngIf="ProfileUserID" 
                                    [UserID]="LoginUserID"
                                    [Username]="LoginUsername" 
                                    [ProfileUserID]="ProfileUserID"
                                    [ProfileUsername]="ProfileUsername"
                                    [ProfileName]="ProfileName"
                                    [ProfileUserImg]="ProfileUserImg"
                                    [ProfileBannerImage]="ProfileBannerImage"
                                    [ProfileImageDirectory]="ProfileImageDirectory">
                            </app-profile-menu-page-top>
                        </div>


                        <ng-container *ngFor="let postData of UserPostsData; let i = index">
                            <div [id]="'post' + ((currentPage - 1) * pageSize + i)" class="post-container" (click)="navigateToPost(postData.UserName, postData.TSID)">

                                <app-post-detail 
                                                *ngIf="ProfileUserID" 
                                                 (reactionsUpdated)="onReactionsUpdated($event.postId, $event.reactions)"
                                                 [Username]="ProfileUsername"
                                                 [UserID]="ProfileUserID"
                                                 [postData]="postData"
                                                 [pageType]="'dashboard'">
                                </app-post-detail>


                            </div>
                            <div *ngIf="isLoading">
                                Loading more posts...
                            </div>
                        </ng-container>

                    </div>
                </div>
            </div>
            <!-- RIGHT SIDE BAR -->
            <div class="col-lg-3 d-none d-lg-block  w-25 h-25 right_side_bar">
                <div class="">
                    <div class="bg-opacity-10 bg-black rounded-pill">
                        <div class="row d-flex align-items-center ">
                            <div class="col-2 text-end fs-6">
                                <span><i class="fa fa-magnifying-glass ps-4"></i></span>
                            </div>
                            <div class="col-10">
                                <input type="text"
                                       class="form-control-lg border-0 me-1 w-75 bg-transparent"
                                       placeholder="Search Twitter">
                            </div>
                        </div>
                    </div>
                    <div class="row bg-opacity-10 bg-black mx-1 my-2 pb-3 rounded-3">
                        <div class="col">
                            <div class="trending">
                                <p class="fs-6 fw-bold py-2">Trends for you</p>
                                <div class="row">
                                    <div class="col-9">
                                        <p class="m-0">Trending in Pakistan</p>
                                    </div>
                                    <div class="col-3 text-end">
                                        <span><i class="fa fa-ellipsis pe-2"></i></span>
                                    </div>
                                </div>
                                <div class="row">
                                    <div class="col">
                                        <p class="fs-6 fw-bold mb-0">Nawaz Sharif</p>
                                        <p class="">12.7k Tweets</p>
                                    </div>
                                </div>

                                <div class="row">
                                    <div class="col-9">
                                        <p class="m-0">Technology . Trending</p>
                                    </div>
                                    <div class="col-3 text-end">
                                        <span><i class="fa fa-ellipsis pe-2"></i></span>
                                    </div>
                                </div>
                                <div class="row">
                                    <div class="col">
                                        <p class="fs-6 fw-bold mb-0">#TikTok</p>
                                        <p class="">101k Tweets</p>
                                    </div>
                                </div>

                                <div class="row">
                                    <div class="col-9">
                                        <p class="m-0">Trending in Pakistan</p>
                                    </div>
                                    <div class="col-3 text-end">
                                        <span><i class="fa fa-ellipsis pe-2"></i></span>
                                    </div>
                                </div>
                                <div class="row">
                                    <div class="col">
                                        <p class="fs-6 fw-bold mb-0">Audio</p>
                                        <p class="">132k Tweets</p>
                                    </div>
                                </div>

                                <div class="row">
                                    <div class="col-9">
                                        <p class="m-0">Trending in Pakistan</p>
                                    </div>
                                    <div class="col-3 text-end">
                                        <span><i class="fa fa-ellipsis pe-2"></i></span>
                                    </div>
                                </div>
                                <div class="row">
                                    <div class="col">
                                        <p class="fs-6 fw-bold mb-0">#Bajwa</p>
                                        <p class="">8,104 Tweets</p>
                                    </div>
                                </div>

                                <div class="row">
                                    <div class="col-9">
                                        <p class="m-0">Trending in Pakistan</p>
                                    </div>
                                    <div class="col-3 text-end">
                                        <span><i class="fa fa-ellipsis pe-2"></i></span>
                                    </div>
                                </div>
                                <div class="row">
                                    <div class="col">
                                        <p class="fs-6 fw-bold mb-0">Shame</p>
                                        <p class="">141k Tweets</p>
                                    </div>
                                </div>

                                <div class="row">
                                    <div class="col-9">
                                        <p class="m-0">Trending in Pakistan</p>
                                    </div>
                                    <div class="col-3 text-end">
                                        <span><i class="fa fa-ellipsis pe-2"></i></span>
                                    </div>
                                </div>
                                <div class="row">
                                    <div class="col">
                                        <p class="fs-6 fw-bold mb-0">#dollarvsrupee</p>
                                        <p class="">2,449 Tweets</p>
                                    </div>
                                </div>

                                <span class="text-info">Show more</span>
                            </div>
                        </div>
                    </div>
                </div>

            </div>
        </div>
    </div>
 